module.exports = __webpack_public_path__ + "static/media/mainCharStairway.d42181e3.png";